import { ChartDataSets } from "chart.js";

export const colors = ["#173F5F", "#33DAFF", "#3CAEA3", "#F6D55C", "#D133FF"];

export const baseOption = (color: string): ChartDataSets => {
  return {
    fill: false,
    backgroundColor: color,
    lineTension: 0,
    borderColor: color,
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0.0,
    borderJoinStyle: "miter",
    pointBorderColor: color,
    pointBackgroundColor: color,
    pointBorderWidth: 1,
    pointRadius: 4,
    pointHitRadius: 10,
  } as ChartDataSets;
};
